// =============================================================================
// AI ASSISTANT TYPES
// =============================================================================

export type AgentType = 'schema' | 'workflow' | 'document' | 'general';

export interface Agent {
  id: AgentType;
  name: string;
  description: string;
  icon: string;
  color: string;
  capabilities: string[];
}

export interface Message {
  id: string;
  role: 'user' | 'assistant' | 'system';
  content: string;
  agentType?: AgentType;
  timestamp: string;
  status?: 'sending' | 'sent' | 'error';
  toolResults?: ToolResult[];
}

export interface ToolResult {
  toolName: string;
  input: unknown;
  result: unknown;
  success: boolean;
}

export interface Conversation {
  id: string;
  title: string;
  agentType: AgentType;
  messages: Message[];
  createdAt: string;
  updatedAt: string;
}

export interface SuggestedPrompt {
  text: string;
  agentType: AgentType;
}

// Agent catalog
export const AGENTS: Agent[] = [
  {
    id: 'schema',
    name: 'Schema Agent',
    description: 'Design and generate data models',
    icon: 'Database',
    color: '#3B82F6',
    capabilities: [
      'Generate entity schemas from descriptions',
      'Suggest field types and relations',
      'Optimize data structures',
      'Create migration scripts',
    ],
  },
  {
    id: 'workflow',
    name: 'Workflow Agent',
    description: 'Design and optimize workflows',
    icon: 'GitBranch',
    color: '#8B5CF6',
    capabilities: [
      'Generate workflow from requirements',
      'Add conditions and loops',
      'Suggest integrations',
      'Optimize flow logic',
    ],
  },
  {
    id: 'document',
    name: 'Document Agent',
    description: 'Generate and process documents',
    icon: 'FileText',
    color: '#10B981',
    capabilities: [
      'Generate documentation',
      'Create form templates',
      'Extract information',
      'Summarize content',
    ],
  },
  {
    id: 'general',
    name: 'Assistant',
    description: 'General help and guidance',
    icon: 'Bot',
    color: '#F59E0B',
    capabilities: [
      'Answer questions',
      'Provide suggestions',
      'Help navigate the app',
      'Explain features',
    ],
  },
];

export const SUGGESTED_PROMPTS: SuggestedPrompt[] = [
  {
    text: 'Create a schema for a leave request system with approvals',
    agentType: 'schema',
  },
  {
    text: 'Design a workflow for employee onboarding',
    agentType: 'workflow',
  },
  {
    text: 'Generate a contact form with validation',
    agentType: 'document',
  },
  {
    text: 'How do I add a relation between two entities?',
    agentType: 'general',
  },
  {
    text: 'Create a customer entity with address and contacts',
    agentType: 'schema',
  },
  {
    text: 'Build an approval workflow with email notifications',
    agentType: 'workflow',
  },
];
